import { jsx } from 'react/jsx-runtime';
import { Box } from '@mui/material';
import { useRef, useLayoutEffect } from 'react';
import { LIST_BOX_CLASSES } from '../Listbox/ListBox.js';
import '../Listbox/ListItem.js';

/**
 * @deprecated Use `Button.Dropdown` instead.
 * This component is scheduled for removal around 01.10.2024.
 * To let us know about blockers you can link [FBI-280](https://supercharged.atlassian.net/browse/FBI-280) in your tasks.
 */
function ButtonDropdownDeprecated({ children, sx, "data-testid": dataTestId, }) {
    const ref = useRef(null);
    const optionsRef = useRef(null);
    const buttonRef = useRef(null);
    const showOptions = () => {
        var _a;
        (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove(LIST_BOX_CLASSES.hidden);
    };
    const hideOptions = () => {
        var _a;
        (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.classList.add(LIST_BOX_CLASSES.hidden);
    };
    useLayoutEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        optionsRef.current = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector("ul");
        buttonRef.current = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.querySelector("button");
        (_c = optionsRef.current) === null || _c === void 0 ? void 0 : _c.classList.add(LIST_BOX_CLASSES.hidden);
        (_d = buttonRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener("mouseenter", showOptions);
        (_e = buttonRef.current) === null || _e === void 0 ? void 0 : _e.addEventListener("mouseleave", hideOptions);
        (_f = optionsRef.current) === null || _f === void 0 ? void 0 : _f.addEventListener("mouseenter", showOptions);
        (_g = optionsRef.current) === null || _g === void 0 ? void 0 : _g.addEventListener("mouseleave", hideOptions);
        (_h = optionsRef.current) === null || _h === void 0 ? void 0 : _h.addEventListener("click", hideOptions);
        return () => {
            var _a, _b, _c, _d;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("mouseenter", showOptions);
            (_b = optionsRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener("click", hideOptions);
            (_c = optionsRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener("mouseenter", showOptions);
            (_d = optionsRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener("mouseleave", hideOptions);
        };
    }, []);
    return (jsx(Box, { "data-testid": dataTestId, ref: ref, sx: sx, children: children }));
}

export { ButtonDropdownDeprecated };
//# sourceMappingURL=Dropdown.js.map
